

import { Entity } from '../entity';
import * as Enumerable from 'linq';
import { OpportunityStage } from './opportunity.stage';
import { FiltersNumberMethod } from '../../utilities/filters.number.utility';
import { FiltersRelativeDateMethod } from '../../utilities/filters.relative.date.utility';

export interface OpportunityViewLookups {
    timezones?: string[];

    // Job Filters
    tags?: Entity[];
    account?: Entity[];
    owner?: Entity[];
    jobType?: Entity[];
    source?: Entity[];
    stage?: OpportunityStage[];
    zones?: Entity[];
    company?: Entity[];
}

export interface OpportunityViewFilters extends OpportunityViewLookups {

    _id?: string;

    total?: number;
    prepaymentOnly?: boolean;

    // Multi - Need to check data inside
    search?: string;

    amount?: FiltersNumberMethod;
    createdAt?: FiltersRelativeDateMethod;
    expectedClose?: FiltersRelativeDateMethod;
    lastActivityDate?: FiltersRelativeDateMethod;
    stageUpdatedAt?: FiltersRelativeDateMethod;

}

export function effectiveOpportunityViewFilters(view: OpportunityViewFilters, refinements: OpportunityViewFilters) {

    const effective: { [k in keyof OpportunityViewFilters] } = {} as OpportunityViewFilters;
    const keys = Object.keys(new OpportunityViewFiltersClass())

    Enumerable.from(keys)
        .forEach(key => {

            const refinement = refinements[key];
            const viewValue = view[key];

            if (Array.isArray(refinement) || Array.isArray(viewValue)) {
                effective[key] = refinement?.length
                    ? refinement
                    : viewValue;
            } else {
                effective[key] = refinement
                    ? refinement
                    : viewValue;
            }

            if (effective[key] == null ||
                (typeof effective[key] !== 'boolean' && Object.keys(effective[key])?.length == 0)
            ) {
                delete effective[key];
            }
        });

    return effective;

}

export function isOpportunityViewFiltersRefined(refinements: OpportunityViewFilters): boolean {

    if (!refinements) return false;
    if (refinements.search && (refinements.search !== null || refinements.search === '')) return true;

    if (refinements?.account?.length) return true;
    if (refinements?.owner?.length) return true;
    if (refinements?.jobType?.length) return true;
    if (refinements?.tags?.length) return true;
    if (refinements?.source?.length) return true;
    if (refinements?.stage?.length) return true;
    if (refinements?.zones?.length) return true;
    if (refinements?.company?.length) return true;
    if (refinements?.timezones?.length) return true;

    if (refinements.expectedClose) return true;
    if (refinements.lastActivityDate) return true;
    if (refinements.createdAt) return true;
    if (refinements.stageUpdatedAt) return true;
    if (refinements.amount) return true;
    if (refinements.prepaymentOnly) return true;

    return false;
}


class OpportunityViewFiltersClass implements Required<OpportunityViewFilters> {
    _id = null

    total: number;
    prepaymentOnly: boolean = false;

    // Multi - Need to check data inside
    search: string = null;

    timezones: string[] = [];

    // Job Filters
    tags: Entity[] = [];
    account: Entity[] = [];
    owner: Entity[] = [];
    jobType: Entity[] = [];
    source: Entity[] = [];
    zones: Entity[] = [];
    company: Entity[] = [];
    stage: OpportunityStage[] = [];

    amount: FiltersNumberMethod = null;
    expectedClose: FiltersRelativeDateMethod = null;
    createdAt: FiltersRelativeDateMethod = null;
    lastActivityDate: FiltersRelativeDateMethod = null;
    stageUpdatedAt: FiltersRelativeDateMethod = null;
}
